import React from 'react';
import { formatPlayerWithdrawalUsd, playerWithdrawalChainSummary, playerWithdrawalSourceLabel, } from './display';
export const PlayerWithdrawalAutoApprovePanel = ({ snapshot, loading, viewerLevel, }) => {
    if (loading) {
        return React.createElement("p", { className: "text-xs text-stone-500" }, "Loading withdrawal auto-approve setting\u2026");
    }
    if (!snapshot)
        return null;
    return (React.createElement("div", { className: "min-w-0 flex-1" },
        React.createElement("h2", { className: "text-sm font-semibold text-stone-900" }, "Player withdrawal auto-approve"),
        React.createElement("p", { className: "mt-1 text-xs text-stone-600" }, "Player withdrawals at or below this amount are approved automatically. Admin sets this value. You cannot change it."),
        React.createElement("p", { className: "mt-3 text-2xl font-bold tabular-nums tracking-tight text-stone-900" }, formatPlayerWithdrawalUsd(snapshot.effective)),
        React.createElement("p", { className: "mt-1 text-xs text-stone-600" }, playerWithdrawalSourceLabel(snapshot, viewerLevel)),
        React.createElement("p", { className: "mt-3 text-xs text-stone-500" }, playerWithdrawalChainSummary(snapshot))));
};
export default PlayerWithdrawalAutoApprovePanel;
